import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from 'src/app/Guards/auth.guard';
import { UserLoginService } from 'src/app/login/userlogin.service';
import { ReportedListingCreateRequestDTO } from 'src/app/real-estate/Interface & Service/reportedListing/reportedListing.interface';
import { ReportedListingService } from 'src/app/real-estate/Interface & Service/reportedListing/reportedListing.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-u-report-listing',
  templateUrl: './u-report-listing.component.html',
  styleUrls: ['./u-report-listing.component.css']
})
export class UReportListingComponent implements OnInit {
  @Input({ required: true }) masterId!: number;
  @Input({ required: true }) masterType!: string;
  private User = inject(UserLoginService).User();
  private activeModal = inject(NgbActiveModal);
  private reportedListingService = inject(ReportedListingService);
  private authGuardService = inject(AuthGuard);
  isLoggedIn!: boolean;
  currentStep = 1;

  issueOptions: string[] = [
    'Property Sold / Rented Out',
    'Incorrect Location or Address',
    'Fake or Misleading Photos',
    'Incomplete Listing Information',
    'Scam or Fraudulent Listing',
    'Fake or AI-generated Photos'
  ];

  // Form values
  selectedIssues: string[] = [];
  comment: string = '';
  name: string = '';
  contact: string = '';

  ngOnInit(): void {
    this.isLoggedIn = this.authGuardService.isLoggedIn();
  }

  onCheckboxChange(event: Event, issue: string) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.checked) {
      if (!this.selectedIssues.includes(issue)) {
        this.selectedIssues.push(issue);
      }
    } else {
      this.selectedIssues = this.selectedIssues.filter(item => item !== issue);
    }
    console.log(this.selectedIssues);

  }

  reportListing() {
    const reason = this.selectedIssues.join(',');

    let data: ReportedListingCreateRequestDTO = {
      userId: this.isLoggedIn ? this.User.userId : 0,
      masterId: this.masterId,
      masterType: this.masterType,
      reason: reason,
      comment: this.comment,
      reportedOn: new Date(),
      status: 'Pending',
      name: this.isLoggedIn ? this.User.userName : this.name,
      phoneNo: this.isLoggedIn ?  this.User.mobileNo : this.contact,
      actionUser: this.isLoggedIn ? this.User.userId.toString() : this.name
    }

    this.reportedListingService.ReportedListing_Create(data).subscribe((res) => {
      this.activeModal.close(res);
      this.showReportSuccessModal();
    })

  }

  private showReportSuccessModal(): void {
    Swal.fire({
      icon: 'success',
      title: 'Report Submitted!',
      html: `The listing has been <b>successfully reported</b>. Our team will review it shortly.`,
      timer: 3500,
      confirmButtonText: 'Okay',
      customClass: {
        popup: 'swal2-border-radius'
      }
    });
  }

  goToStep(step: number) {
    this.currentStep = step;
  }

  cancelModal() {
    this.activeModal.dismiss();
  }



}
